import client from './client';

/**
 * Submit a review for a completed booking
 * @param {Object} reviewData - { propertyId, bookingId, rating, title, content }
 * @returns {Promise<Object>} Created review
 */
export const submitReview = async (reviewData) => {
    const { data } = await client.post('/api/reviews', reviewData);
    return data;
};
